import React, { useEffect, useState, useCallback, useContext } from 'react'
import { Rating } from 'react-simple-star-rating'
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useFetch } from '../../api/FetchApiData';
import { MediaUrl } from '../../utils/media/Media';
import { useInfiniteScroll } from '../../utils/InfiniteScroll';
import { AppContext, UserContext } from '../../../AppContextProvider';
import orders_icon from '../../icons/orders.webp';
import remove_icon from '../../icons/remove.webp';
import Popup from 'reactjs-popup';
import { PartnerOrders } from './Partner';
import { useTranslation } from 'react-i18next';

if (isMobile)
    import('./partners_mob.css').then(() => {});
else
    import('./partners.css').then(() => {});


function Partners() {
  
    const navigator = useNavigate();
    const fetchData = useFetch();
    const [partners,setPartners] = useState([]);
    const [page,setPage] = useState({CurrentPage:1,MaxPage:1});
    const [hasMore,setHasMore] = useState(true);
    const {t} = useTranslation();
    const [AppState,setAppState] = useContext(AppContext);
    const [UserState,setUserState] = useContext(UserContext);

    const FetchPartners = useCallback(async ()=>{
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.PostData({},`partners/filter/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    if(page.CurrentPage>result.maxpage)
                        setHasMore(false);
                    else
                    {setPartners([...partners,...result.partners]);setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});}
                }
            })
        }
    },[page.CurrentPage]);

    useEffect(()=>{
        if(!UserState.is_staff)
            navigator('/')
    },[])

    const LogoSrc = (part)=>{
        try{
            return MediaUrl(part.logo.image);
        }
        catch{
            return '/images/icons/store.webp';
        }
    }

    const Delete = (_partner)=>
    {
        fetchData.DeleteData({},`partner/${_partner.id}/`).then((result)=>{
        })
    }

    const LoadMoreRef = useInfiniteScroll(FetchPartners,hasMore);

    return (
    <div className='partners'>
        <input type='button' onClick={e=>{navigator('/user/partner/add/')}} className='partners-addbtn' value={t('user.ajout-partenaire')} />
        {partners.map((part,index)=>{return(
            <div key={index} className='partners-partner'>
                <img src={LogoSrc(part)} className='partner-img' />
                <h4 style={{marginBottom:'5px',margin:'0px',fontSize:'small'}}>{part.name} <Rating initialValue={part.note} style={{marginLeft:'7px'}} size={10} /></h4>
                <div style={{marginBottom:'5px',fontSize:'x-small',textAlign:isMobile?'center':'left'}}>
                    <div style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                        <label style={{marginLeft:'10px',marginRight:'15px'}}>{t('authentication.telephone')}</label> 
                        <label>{part.phone}</label>
                    </div>
                    <div style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                        <label style={{marginLeft:'10px',marginRight:'15px'}}>{t('partners.ville')}</label> 
                        <label>{part.ville}</label>
                    </div>
                    <div style={{display:'flex',flexDirection:AppState.settings.lang==='ar'?'row-reverse':'row'}}>
                        <label style={{marginLeft:'10px',marginRight:'15px'}}>{t('authentication.email')}</label> 
                        <label>{part.email}</label>
                    </div>
                </div>
                <p className='partners-description' style={{color:'gray',fontSize:'x-small'}}>{part.description}</p>
                    <div style={{marginTop:'10px',textAlign:'right'}}>
                        <Popup trigger={
                        <button style={{position:'relative',padding:'5px',marginRight:'10px',width:'30px',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                            <img src={orders_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                            {/*<label style={{display:'block',padding:'5px 0px 5px 0px'}}>Colis</label>*/}
                            <span style={{fontSize:'xx-small',position:'absolute',top:'-5px',right:'-5px',backgroundColor:'rgba(0,0,0,0.8)',color:'white',borderRadius:'3px',padding:'3px 3px 3px 3px'}}>{part.colis_counter}</span>
                        </button>}>
                            {close=>(
                                <fieldset style={{position:'fixed',top:'0px',display:'flex',padding:'0px',flexDirection:'column',left:'0px',margin:'auto',backgroundColor:'rgba(255,255,255,0.5)',width:'100%',height:'100vh'}}>
                                    <div style={{width:'100%',height:'100vh',position:'fixed',top:'80px',left:'0px',margin:'auto',backgroundColor:'rgba(0,0,0,0.8)'}}>
                                        <PartnerOrders partner_id={part.id} close={e=>{close()}} />          
                                    </div>
                                </fieldset>       
                            )}
                        </Popup>
                        <button style={{position:'relative',padding:'5px',marginRight:'10px',width:'30px',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                            <img src={orders_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                            {/*<label style={{display:'block',padding:'5px 0px 5px 0px'}}>Paiements</label>*/}
                            <span style={{fontSize:'xx-small',position:'absolute',top:'-5px',right:'-5px',backgroundColor:'rgba(0,0,0,0.8)',color:'white',borderRadius:'3px',padding:'3px 3px 3px 3px'}}>{part.colis_counter}</span>
                        </button>
                        <button onClick={e=>{Delete(part)}} style={{position:'relative',padding:'5px',marginRight:'10px',width:'30px',height:'30px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                            <img src={remove_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                            {/*<label style={{display:'block',padding:'5px 0px 5px 0px'}}>Supprimer</label>*/}
                        </button>
                        <input onClick={e=>{navigator('/user/partner/'+part.id+'/')}} type='button' style={{border:'none',backgroundColor:'gold',borderRadius:'5px',height:'30px',paddingLeft:'20px',paddingRight:'20px',marginRight:'10px',width:'fit-content',fontSize:'x-small'}} value={'Voir'} />
                    </div>
        </div>)})}
        <div ref={LoadMoreRef} style={{height:'20px'}}/>
    </div>
)
}

export default Partners;
